<p class="ui-heading-2-bold--s">Room management</p>

<div class="filters-container">
  <rds-accordion size="m">
    <rds-expansion-panel [(expanded)]="filtersExpanded">
      <rds-expansion-panel-header>
        <rds-panel-title>
          <h2 class="rds-expansion-panel-heading">Filters</h2>
        </rds-panel-title>
      </rds-expansion-panel-header>
      <form [formGroup]="filterForm" class="filters-form">
        <div class="filter-row row gy-5 align-items-end">
          <div class="col-12 col-l-8">
            <label for="roomNameFilter" class="filter-label">Room name</label>
            <rds-search
              size="m"
              id="roomNameFilter"
              autoSearch
              formControlName="roomName"
              placeholder="Search by room name">
            </rds-search>
          </div>
          <div class="col-12 col-l-4">
            <rds-form-field size="m" labelPosition="top">
              <rds-control-label>Room Type</rds-control-label>
              <rds-multi-select
                placeholder="Select Room Type"
                formControlName="roomType">
                @for (type of roomTypes(); track type) {
                  <rds-multi-select-option [value]="type">{{
                    type
                  }}</rds-multi-select-option>
                }
              </rds-multi-select>
            </rds-form-field>
          </div>
        </div>
        <div class="filter-row row gy-5 align-items-end">
          <div class="col-12 col-m-6 col-l-3">
            <rds-form-field labelPosition="top" size="m">
              <rds-control-label>Site</rds-control-label>
              <rds-multi-select
                placeholder="Select Site"
                formControlName="siteName">
                @for (site of siteNames(); track site) {
                  <rds-multi-select-option [value]="site">{{
                    site
                  }}</rds-multi-select-option>
                }
              </rds-multi-select>
            </rds-form-field>
          </div>
          <div class="col-12 col-m-6 col-l-3">
            <rds-form-field labelPosition="top" size="m">
              <rds-control-label>Building</rds-control-label>
              <rds-multi-select
                placeholder="Select Building"
                formControlName="buildingName">
                @for (building of buildingNames(); track building) {
                  <rds-multi-select-option [value]="building">{{
                    building
                  }}</rds-multi-select-option>
                }
              </rds-multi-select>
            </rds-form-field>
          </div>
          <div class="col-12 col-m-6 col-l-3">
            <rds-form-field labelPosition="top" size="m">
              <rds-control-label>Floor</rds-control-label>
              <rds-multi-select
                placeholder="Select Floor"
                formControlName="floorName">
                @for (floor of floorNames(); track floor) {
                  <rds-multi-select-option [value]="floor">{{
                    floor
                  }}</rds-multi-select-option>
                }
              </rds-multi-select>
            </rds-form-field>
          </div>
          <div class="col-12 col-m-6 col-l-3">
            <rds-form-field labelPosition="top" size="m">
              <rds-control-label>Min. capacity</rds-control-label>
              <input
                type="number"
                formControlName="capacity"
                placeholder="Min. capacity"
                min="0"
                rdsInput />
            </rds-form-field>
          </div>
          <div class="col-12 col-m-6 col-l-3">
            <button
              rds-secondary-button
              type="button"
              (click)="clearFilters()"
              size="m"
              class="clear-button">
              Clear
            </button>
          </div>
        </div>
      </form>
    </rds-expansion-panel>
  </rds-accordion>
</div>

@if (isRoomListLoading()) {
  <div class="loader">
    <rds-progress-spinner></rds-progress-spinner>
  </div>
} @else {
  <bad-rooms-list-table
    [rooms]="filteredRooms()"
    (rowClicked)="openRoomDetails($event)">
  </bad-rooms-list-table>
}
